"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.noop = void 0;

/**
 * Do absolutely nothing
 */
var noop = function noop() {};

exports.noop = noop;


//////////////////
// WEBPACK FOOTER
// ./~/react-player-controls/dist/utils.js
// module id = 302
// module chunks = 168707334958949